/**
 * SectionHeader — DS Organism
 */

import styles from './SectionHeader.module.css';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  separator?: boolean;
  actions?: React.ReactNode;
  className?: string;
}

export function SectionHeader({ title, subtitle, separator = true, actions, className = '' }: SectionHeaderProps) {
  return (
    <div className={`${styles.header} ${className}`}>
      <div className={styles.row}>
        <div className={styles.text}>
          <h2 className={styles.title}>{title}</h2>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {separator && <div className={styles.sep} />}
    </div>
  );
}
